import { cx } from "@suse-o11y/class-variance";
import React from "react";

import styles from "./_select.module.css";

const LazyItem = React.lazy(async () => {
	// biome-ignore lint/style/noRestrictedImports: component usage
	const { Item } = await import("@radix-ui/react-select");

	return { default: Item };
});

const LazyItemText = React.lazy(async () => {
	// biome-ignore lint/style/noRestrictedImports: component usage
	const { ItemText } = await import("@radix-ui/react-select");

	return { default: ItemText };
});

export type SelectItemProps = React.ComponentPropsWithoutRef<typeof LazyItem>;

export const SelectItem = React.forwardRef<React.ElementRef<typeof LazyItem>, SelectItemProps>(
	({ className, children, ...props }, ref) => (
		<LazyItem className={cx(styles.item, className)} ref={ref} {...props}>
			<LazyItemText>{children}</LazyItemText>
		</LazyItem>
	),
);

if (import.meta.env.DEV) {
	SelectItem.displayName = "SelectItem";
}
